import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for hero headings
export const MaskLines = ({ lines, className, lineClassName, start = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className={`block ${lineClassName || ""}`}
          initial={{ y: "110%" }}
          animate={start ? { y: "0%" } : { y: "110%" }}
          transition={{ duration: 1.1, delay: 0.15 + i * 0.13, ease: [0.76, 0, 0.24, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`text-xs md:text-sm uppercase tracking-[0.28em] text-gold ${className}`}>{children}</span>
);
